export default ({ app }, inject) => {
    inject('validateLink', (link) => {
        const errorUrl = '/undefined';

        if (!link) {
            return false;
        }

        if (typeof link !== 'string') {
            link = app.$prismic.linkResolver(link);
        }
        return link !== errorUrl;
    });
    return app;
};